<template>
    <div class="content">
        <div class="main_popup" v-if="popupList.length>0" v-show="has_haedPop">

          <div v-for="pop in popupList" :key="`pop${pop.p_idx}`" :id="`pop${pop.p_idx}`" style="position: absolute" class="pop">
                <div class="first_popup" :style="`background-image: url(${returnPopupImage(pop)})`"
                     @click="goDetail(pop.p_idx)"></div>
                <div class="second_popup">
                    <!--<div class="popup_check">
                        <input type="checkbox" :id="`checked${pop.p_idx}`" v-model="checkHide[pop.p_idx]">
                    </div>-->
                    <input type="checkbox" :id="`checked${pop.p_idx}`" v-model="checkHide[pop.p_idx]">
                    <label :for="`checked${pop.p_idx}`" > <span></span> </label>

                    <div class="popup_text"> 오늘하루 보지않음</div>
                    <button class="popup_button" @click="hidePop(pop.p_idx)">닫기</button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import imageOption from "@/mixins/imageOption";

    export default {
        name: "PopupComponent",
        mixins: [imageOption],
        components: {},
        props: {},
        data() {
            return {
                popupList: [],
                has_haedPop: false,
                checkHide: {},
            }
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {
            this.getPopup()
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            getPopup() {
                let params = {
                    ip: 0,
                    isdi: 1,
                }
                try {
                    this.$api.$popup.getPopup(params).then(res => res.Data.Result).then(res => {
                        if (res.Info.type == 1) {
                            let today = this.$moment().format('YYYY-MM-DD');
                            this.popupList = res.List;
                            res.List.forEach(pop => {
                                this.checkHide[pop.p_idx] = false
                            })
                            if (this.popupList.length > 0) {
                                this.$forceUpdate();
                                let localHidePop = this.$localStorage.get('SafeCheckHidePop');
                                let $this = this;
                                let newLocalHidePop = [];
                                window.setTimeout(() => {
                                    this.has_haedPop = true;
                                    if (localHidePop != null && localHidePop.length > 0) {
                                        localHidePop.forEach(pop => {
                                            if (pop.date === today) {
                                                let popDiv = document.getElementById(`pop${pop.p_idx}`);
                                                if (popDiv) {
                                                    popDiv.style.display = 'none';
                                                }
                                            }
                                            if ($this.$moment(pop.date).isSameOrAfter(today)) {
                                                newLocalHidePop.push(pop);
                                            }
                                        })
                                        this.$localStorage.set('SafeCheckHidePop', newLocalHidePop);
                                    }
                                }, 500);
                            }

                        }
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            hideTodayPop(p_idx) {
                let localHidePop = this.$localStorage.get('SafeCheckHidePop');
                if (localHidePop != null && localHidePop.length > 0) {
                    let popWrap = localHidePop.filter(pop => pop.p_idx === p_idx);
                    if (popWrap.length > 0) {
                        localHidePop.forEach(pop => {
                            if (pop.p_idx === p_idx) {
                                pop.date = this.$moment().format('YYYY-MM-DD')
                            }
                        });
                    } else {
                        let hidePop = {
                            date: this.$moment().format('YYYY-MM-DD'),
                            p_idx: p_idx
                        }
                        localHidePop.push(hidePop);
                    }

                } else {
                    localHidePop = [{
                        date: this.$moment().format('YYYY-MM-DD'),
                        p_idx: p_idx
                    }]
                }
                this.$localStorage.set('SafeCheckHidePop', localHidePop);
                let popDiv = document.querySelector(`#pop${p_idx}`)
                popDiv.style.display = 'none';
            },
            hidePop(p_idx) {
                if (this.checkHide[p_idx]) {
                    this.hideTodayPop(p_idx)
                } else {
                    let popDiv = document.querySelector(`#pop${p_idx}`)
                    popDiv.style.display = 'none';
                }
            },
            returnPopupImage(pop) {
                return pop.hasOwnProperty('File') ? `${pop.File[0].org_url}?${this.setImageOptions(394, 434, 'png')}` : ''

            },
            goDetail(p_idx) {
                this.$router.push(`/popup/${p_idx}`)
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>